import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {SetupIntent} from '../types';
import {stage} from "../../../config/stage";


export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<SetupIntent, 'id'>,
    handleSubmit: (values: SetupIntent) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: SetupIntent) => {
        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {
        customerId: '',
        description: '',
        paymentMethod: '',
        usage: 'offSession',
    } as SetupIntent;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
